<template>
  <div class="contact">
    <h2><a v-on:click="openSidebar()"><i class="material-icons">contact_mail</i> <span>Contact</span></a></h2>
    <ul>
      <li><a href="mailto:hello@timganter.io">hello@timganter.io</a></li>
      <li><a href="//twitter.com/timganter">@timganter</a></li>
      <li><a href="//www.linkedin.com/in/timganter">LinkedIn</a></li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'contact',
  methods: {
    openSidebar: function (event) {
      let app = document.getElementById('app')

      if (app.classList.contains('s-sidebar-toggled') && (window.innerWidth > 960)) {
        app.classList.remove('s-sidebar-toggled')
      } else if (!app.classList.contains('s-sidebar-toggled') && (window.innerWidth < 960)) {
        app.classList.add('s-sidebar-toggled')
      }
    }
  }
}
</script>

<style lang="scss">
@import "./src/sass/components/about/contact";
</style>



// WEBPACK FOOTER //
// Contact.vue?791df6b5